
export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-neutral-900 border-t border-neutral-800 text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <img 
                src="https://public.readdy.ai/ai/img_res/705391acbc6edace56d666e3d41c23dc.jpg" 
                alt="Nappy Rootz" 
                className="h-16 w-auto mb-4"
              />
              <span className="text-xl font-bold">Nappy Rootz</span>
            </div>
            <p className="text-stone-400 text-sm mb-6">
              Celebrating Black excellence through precision barbering and authentic community connection.
            </p>
            <div className="flex gap-3">
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center border border-neutral-700 rounded-lg hover:bg-amber-500 hover:border-amber-500 hover:text-black transition-colors cursor-pointer">
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center border border-neutral-700 rounded-lg hover:bg-amber-500 hover:border-amber-500 hover:text-black transition-colors cursor-pointer">
                <i className="ri-facebook-line text-lg"></i>
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center border border-neutral-700 rounded-lg hover:bg-amber-500 hover:border-amber-500 hover:text-black transition-colors cursor-pointer">
                <i className="ri-twitter-x-line text-lg"></i>
              </a>
              <a href="https://tiktok.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center border border-neutral-700 rounded-lg hover:bg-amber-500 hover:border-amber-500 hover:text-black transition-colors cursor-pointer">
                <i className="ri-tiktok-line text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">QUICK LINKS</h4>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('home')} className="text-stone-400 hover:text-amber-500 transition-colors text-sm cursor-pointer">
                  Home
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="text-stone-400 hover:text-amber-500 transition-colors text-sm cursor-pointer">
                  Services
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('gallery')} className="text-stone-400 hover:text-amber-500 transition-colors text-sm cursor-pointer">
                  Gallery
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('book')} className="text-stone-400 hover:text-amber-500 transition-colors text-sm cursor-pointer">
                  Book
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">SERVICES</h4>
            <ul className="space-y-3">
              <li className="text-stone-400 text-sm">Classic Cuts</li>
              <li className="text-stone-400 text-sm">Beard Sculpting</li>
              <li className="text-stone-400 text-sm">Line Up's</li>
              <li className="text-stone-400 text-sm">Loc Maintenance</li>
              <li className="text-stone-400 text-sm">Kid's Cuts</li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold text-white mb-4">CONTACT</h4>
            <div className="space-y-3 text-sm">
              <p className="flex items-start gap-2 text-stone-400">
                <i className="ri-map-pin-line text-amber-500 mt-1"></i>
                <span>50 Parkins Mill Road<br />Greenville, SC 29607</span>
              </p>
              <p className="flex items-center gap-2 text-stone-400">
                <i className="ri-phone-line text-amber-500"></i>
                <a href="tel:+18644499072" className="hover:text-amber-500 transition-colors">864.449.9072</a>
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-neutral-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-stone-500 text-sm">
            © 2024 Nappy Rootz. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-stone-500 hover:text-amber-500 text-sm transition-colors cursor-pointer">
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
